import App from "./App";
import { AppRegistry } from "react-native";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { initGA } from "./utils/ga";

// Initialise Google Analytics (no-op unless REACT_APP_GA_MEASUREMENT_ID is set).
initGA();

AppRegistry.registerComponent("App", () => App);

AppRegistry.runApplication("App", {
  initialProps: {},
  rootTag: document.getElementById("root"),
});

serviceWorker.unregister();
